import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/solution/xiaolv.png'
import _imports_1 from '@/assets/images/solution/zaozuo.png'
import _imports_2 from '@/assets/images/solution/hudong.png'
import _imports_3 from '@/assets/images/solution/zichan.png'


const _hoisted_1 = { class: "industry" }
const _hoisted_2 = { class: "hytd-box" }
const _hoisted_3 = { class: "hytd" }
const _hoisted_4 = { class: "images" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "title" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "fays" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "yycj" }
const _hoisted_11 = { class: "yycj-content" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "yyal" }
const _hoisted_14 = { class: "yyal-content" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "content" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "detail" }

import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndustryModel',
  setup(__props) {

const loadUrl: any = ref({})

const store = useStore()
const router = useRouter()
const casesListAll: any = ref([])
const prospects = [
  {
    title: '互动性较弱',
    content: '传统培训模式互动性和参与感较弱，缺乏场景感，无法达到真实工作环境下的实操模拟培训及考核要求。',
    url: require('@/assets/images/solution/disadvantage1.png'),
    src: require('@/assets/images/solution/disadvantage-icon1.png')
  },
  {
    title: '数字化不足',
    content: '传统培训模式在实际操作过程中缺少量化参数及考核数据，无法形成企业组织培训数字化资产。',
    url: require('@/assets/images/solution/disadvantage2.png'),
    src: require('@/assets/images/solution/disadvantage-icon2.png')
  },
  {
    title: '培训成本高',
    content: '高危行业传统新员工操作培训成本高并带有安全风险，培训成本高，培训效率亟待提高。',
    url: require('@/assets/images/solution/disadvantage3.png'),
    src: require('@/assets/images/solution/disadvantage-icon3.png')
  }
]

const toDetail = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
}

onMounted(async () => {
  selectCommonElement({ columnId: 4, appId: 2 }).then((res: any) => {
    casesListAll.value = [...res].filter(e => e.industry == 2).sort((a, b) => (a.sortNum || 0) - (b.sortNum || 0)) || []
  })

  const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
  const industryMp4: any = await asynchronousRetrieval('webimg/gif/industry.gif');
  loadUrl.value = { fays_bg, industryMp4 }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title-font-style" }, "工业解决方案", -1)),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "illustrate" }, [
      _createElementVNode("div", null, "使用XR技术模拟复杂机械设备的装配、调试、维修维护等专业操作培训，提高员工培训效率，降低操作失误率，减少安全风险，为企业降本增效。")
    ], -1)),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "subtitle" }, "行业痛点", -1)),
    _cache[6] || (_cache[6] = _createElementVNode("div", null, [
      _createElementVNode("div", { class: "disadvantage" }, "伴随着工业领域的产业技术升级，数字化工厂的建设对企业传统培训做业流程提出新的挑战。工作流程复杂，设备操作复杂的特定行业需要高效的标准化的操作流程培训与考核。")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(prospects, (item, index) => {
          return _createElementVNode("div", { key: index }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: item.url
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: item.src
                }, null, 8, _hoisted_7),
                _createElementVNode("span", null, _toDisplayString(item.title), 1)
              ]),
              _createElementVNode("div", null, _toDisplayString(item.content), 1)
            ])
          ])
        }), 64))
      ])
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "subtitle" }, "方案优势", -1)),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("img", {
        src: loadUrl.value.fays_bg
      }, null, 8, _hoisted_9),
      _cache[0] || (_cache[0] = _createStaticVNode("<div data-v-e35a7f2e><div data-v-e35a7f2e><div class=\"title\" data-v-e35a7f2e><img src=\"" + _imports_0 + "\" data-v-e35a7f2e><span data-v-e35a7f2e>培训效率提升</span></div><div data-v-e35a7f2e>XR可视化培训相比传统方式，更为直观易学，有效缩短员工培训时间，提高培训效率。</div></div><div data-v-e35a7f2e><div class=\"title\" data-v-e35a7f2e><img src=\"" + _imports_1 + "\" data-v-e35a7f2e><span data-v-e35a7f2e>操作流程规范</span></div><div data-v-e35a7f2e>AR标准化操作流程指导，配置可视化参数，规范员工作业过程，提升员工工作质量，从而提高企业效率。</div></div></div><div data-v-e35a7f2e><div data-v-e35a7f2e><div class=\"title\" data-v-e35a7f2e><img src=\"" + _imports_2 + "\" data-v-e35a7f2e><span data-v-e35a7f2e>互动参与感强</span></div><div data-v-e35a7f2e>基于实际环境、设备，以三维化多媒体素材为主，过程多样化智能交互，减少对传统纸质手册和专家的依赖，并结合具体情况提供更适合的情景培训。</div></div><div data-v-e35a7f2e><div class=\"title\" data-v-e35a7f2e><img src=\"" + _imports_3 + "\" data-v-e35a7f2e><span data-v-e35a7f2e>沉淀数字资产</span></div><div data-v-e35a7f2e>培训过程中不断积累沉淀企业数字化内容，形成企业自有知识库。</div></div></div>", 2))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "subtitle" }, "应用场景", -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("img", {
          src: loadUrl.value.industryMp4
        }, null, 8, _hoisted_12)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "subtitle" }, "应用案例", -1)),
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(casesListAll.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (toDetail(item.relatedHtmlId, item.title))
          }, [
            _createElementVNode("img", {
              src: item.ossPath
            }, null, 8, _hoisted_16),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_19, _toDisplayString(item.introduction), 1)
            ])
          ], 8, _hoisted_15))
        }), 128))
      ])
    ])
  ]))
}
}

})